import styled from 'styled-components';

export const AppFooter = styled.footer`
  display: block;
  background: #fff;
  padding: 16px 0;
  text-align: center;
  border-top: 1px solid #ccc;
  color: #383c42;
  font-size: 13px;
  min-width: 100%;
  flex-grow: 0;
  flex-shrink: 0;

  > * + * {
    margin-left: 8px;
  }
`;
